
import {combineLatest as observableCombineLatest,  Observable ,  Subscription } from 'rxjs';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { FormControl } from '@angular/forms';
import { UtilitiesService } from '../../../services/utilities.service';
import { AppState } from '../../../interfaces/app-state.interface';

@Component({
    selector: 'tr-suitability-question-unique-answer',
    templateUrl: './tr-suitability-question-unique-answer.component.html',
    styleUrls: ['./tr-suitability-question-unique-answer.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class TrSuitabilityQuestionUniqueAnswerComponent {

    @Input() set code(value: string) {
        this._code = value;
        this.init(value);
    }
    @Input() public formCtrlName: FormControl = new FormControl();

    public question: any;
    public answerList = [];
    public suitability$: Observable<any>;
    public answerGuid: string;
    private questionText: string;
    private suitabilitySubscription: Subscription;
    // tslint:disable-next-line:variable-name
    private _code: string;

    constructor(
        private store: Store<AppState>,
        private utilsService: UtilitiesService,
    ) {

        this.answerGuid = utilsService.guid();
        this.suitability$ = this.store.select((s) => s.suitability);

    }

    public init(code: string) {

        if (!code) return;
        if (this.suitabilitySubscription) this.suitabilitySubscription.unsubscribe();

        this.suitabilitySubscription =  observableCombineLatest(
            this.store.select((s) => s.suitability.questions),
            this.store.select((s) => s.suitability.answers),
            this.store.select((s) => s.suitability.usersAnswers),
        )
        .subscribe( ([questions, answers, usersAnswers]) => {

            // Pergunta
            this.question = questions.find((e) => e.code === this._code );
            if ( this.question && answers && usersAnswers) {
                this.answerList = answers.filter((e) => ( e && e.questionID === this.question.id ) );
                const relatedAnswer = usersAnswers.find((a) => a.questionID === this.question.id);
                if (relatedAnswer) this.changeValue(relatedAnswer);
            }

        });
    }

    public changeValue(value: any) {
        this.formCtrlName.setValue({
            answerID: value.answerID,
            questionID: this.question.id,
        });
    }
}
